import { FETCH_CONTACTS_COMMON_EMAILS, UPDATE_CONTACTS_COMMON_EMAILS } from "./actionTypes";

const inititalStore = {
    commonEmails: [],
    onceFetched: false,
}

const getMyEmailsList = (domains) => {
    return Array.isArray(domains) ? domains : []
}
export const contactsReducer = (store=inititalStore, action) => {
    const {type, payload} = action;
    switch(type){
        case `${FETCH_CONTACTS_COMMON_EMAILS}_SUCCESS`: {
            const {domains} = payload;
            const emails = getMyEmailsList(domains)
            return {
                ...store,
                commonEmails: emails,
                onceFetched:true
            }
        }
        case `${UPDATE_CONTACTS_COMMON_EMAILS}_SUCCESS`:{
            const {domains} = payload;
            const emails = getMyEmailsList(domains)
            return {
                ...store,
                commonEmails: emails
            }
        }
        default: return store
    }
}